import { Tabs } from 'react-tabs';
import './Tabs.css';

export const TabsWrapper = (props) => {
  return (
    <Tabs className={props.className} style={props.style}>
      {props.children}
    </Tabs>
  )
}